module.exports = __webpack_public_path__ + "static/media/portrait.5674e4a9.jpeg";